import {Injectable} from '@angular/core';

import {Languages} from '../enums/languages';
import {LocalisationEventsEmitter} from '../events/localisation.events';
import {StorageService} from './storage.service';
import {Observable, Observer} from 'rxjs';
import {HttpClient} from '@angular/common/http';

declare const require: (path: string) => { [key: string]: string; };

@Injectable()
export class LocalisationService {
    private readonly LANGUAGE_KEY: string = 'LANGUAGE_KEY';

    language: Languages;
    languageDictionary: { [key: string]: string; };

    constructor(
        private readonly httpClient: HttpClient,
        private readonly localisationEventsEmitter: LocalisationEventsEmitter,
        private readonly storageService: StorageService
    ) {
        this.localisationEventsEmitter.languageChanged$
            .subscribe(language => this.useLanguage(language));
    }

    useLanguage(language: Languages) {
        this.language = language;
        this.languageDictionary = require(`../../../../../config/locales/${this.language.toLowerCase()}.json`);

        this.setLanguage(this.language);
    }

    localise(string: string) {
        return this.languageDictionary[string];
    }

    setLanguage(language: Languages): void {
        this.storageService.setItem(this.LANGUAGE_KEY, language);
    }

    getLanguage(): Languages {
        return this.storageService.getItem(this.LANGUAGE_KEY) as Languages;
    }

    getAutoLanguage(): boolean {
        return this.storageService.getItem(this.LANGUAGE_KEY + '_auto') === '1';
    }

    setAutoLanguage(): void {
        this.storageService.setItem(this.LANGUAGE_KEY + '_auto', '1');
    }

    getUserIpData(): Observable<string> {
        return new Observable((observer: Observer<string>) => {
            const xmlHttp = new XMLHttpRequest();
            xmlHttp.open('GET', 'https://ipinfo.io/json?token=4eb2ef0c92b7ae', false); // false for synchronous request
            xmlHttp.send(null);
            observer.next(JSON.parse(xmlHttp.responseText));
            observer.complete();
        });
    }

    getUserIp(): Observable<string> {
        return new Observable((observer: Observer<string>) => {
            const xmlHttp = new XMLHttpRequest();
            xmlHttp.open('GET', 'https://api.ipify.org?format=json', false); // false for synchronous request
            xmlHttp.send(null);
            observer.next(JSON.parse(xmlHttp.responseText)['ip']);
            observer.complete();
        });
    }

    getIpCountryData(ip: string): Observable<any> {
        return new Observable((observer: Observer<string>) => {
            const xmlHttp = new XMLHttpRequest();
            xmlHttp.open('GET', 'https://api.iplocation.net/?ip=' + ip, true); // false for synchronous request

            xmlHttp.onreadystatechange = function () {
                if (this.readyState === 4 && this.status === 200) {
                    observer.next(JSON.parse(xmlHttp.responseText));
                    observer.complete();
                }
            };

            xmlHttp.setRequestHeader('Content-Type', 'application/json');
            xmlHttp.send(null);
        });
    }
}
